module.exports = __webpack_public_path__ + "static/otherCompanys-2f3a73fbc26b768c66325ef562c3f21d.svg";